module.exports = __webpack_public_path__ + "src/assets/img/lxwm_03@2x.f0adf379.png";